import { Box, ButtonProps, Text, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { WizardStepData } from './types';
import { IconPropsType } from '../../icons/types';
import { CheckCircleIcon } from '../../icons';

export type WizardStepProps = ButtonProps & {
  data: WizardStepData;
  iconProps?: IconPropsType;
  onClick?: () => void;
  isActive?: boolean;
  isDone?: boolean;
};

/**
 * WizardSidebarStep component
 * @private
 */
export const WizardSidebarStep: React.FC<WizardStepProps> = ({
  data,
  iconProps,
  onClick,
  isActive,
  isDone,
  disabled,
  ...buttonProps
}) => {
  const { t } = useTranslation();

  const Icon = data.icon;

  return (
    <UnstyledButton
      onClick={onClick}
      p={4}
      sx={theme => ({
        minHeight: 24,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        borderRadius: 4,
        backgroundColor: isActive ? theme.colors.blue[1] : undefined,
        color: isActive ? theme.colors.blue[0] : undefined,
        '&:hover': {
          color: disabled ? undefined : theme.colors.blue[0],
        },
        '&:disabled': {
          color: 'inherit',
          backgroundColor: 'transparent',
        },
      })}
      disabled={disabled}
      {...buttonProps}
    >
      <Box
        sx={{
          width: 24,
          height: 24,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Icon size={24} {...iconProps} />
      </Box>
      <Box sx={{ flex: '1 0 auto' }}>
        <Text fz="md" fw={600}>
          {t(data.label)}
        </Text>
      </Box>
      {isDone && (
        <Box
          sx={theme => ({
            width: 24,
            height: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: theme.colors.green[6],
          })}
        >
          <CheckCircleIcon size={18} />
        </Box>
      )}
    </UnstyledButton>
  );
};
